import { selectFormById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"

import { appStore } from "../../../../../../../../store"
import { formSettingsDetailViewStaticData } from "../../../../../../../../views/FormSettingsDetailView/constants"
import { FormSettingsDetailView } from "../../../../../../../../views/FormSettingsDetailView/FormSettingsDetailView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/settings/forms/$formId/")({
	component: FormSettingsDetailView,
	staticData: formSettingsDetailViewStaticData,
	loader: ({ params }) => {
		const form = selectFormById(params.formId)(appStore.getState())
		if (!form) throw notFound()
	},
})
